import "./client-dashboard.scss"
import attentionIcon from "./icons/attentionChat.svg"
import attentionArrowIcon from "./icons/attentionArrow.svg"
import upcomingIcon from "./icons/upcomingIcon.svg"
import attentionOfferIcon from "./icons/attentionOfferIcon.svg"
import attentionTasksIcon from "./icons/attentionTasks.svg"
import col1Icon from "./icons/col1.svg"
import col2Icon from "./icons/col2.svg"
import col3Icon from "./icons/col3.svg"
import rollOverInfoIcon from "./icons/rollOverInfo.svg"
import {NavLink, useHistory} from "react-router-dom";
import React, {CSSProperties, FC, useContext, useEffect, useLayoutEffect, useRef, useState} from "react";
import {MainContextProvider} from "../../../context/MainContext";
import customAxios from "../../../service/api/interceptors";
import moment from "moment";
import {CallListTypes} from "../../FollowUp/FollowUpList/FollowUpNewCalls/FollowUpNewCalls";
import {CustomLoader} from "../../../components/UI/CustomLoader/CustomLoader";
import {CSSTransition} from "react-transition-group";
import {FollowUpType} from "../../FollowUp/FollowUpList/FollowUpList";
import {RollOverModal} from "./RollOverModal";
import {closeAbroadModal} from "../../../redux/slices/WelcomeChain";
import {WelcomeAboard} from "../../../components/other/WelcomeData/WelcomeAboard/WelcomeAboard";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../redux/store";
import {CustomTour} from "./CustomTour/CustomTour";

export const ClientDashboard = () => {
    const isAbroadModal = useSelector((state: RootState) => state.welcomeChain.abroadModal);
    const { setModalType } = useContext(MainContextProvider);
    const dispatch = useDispatch();
    const history = useHistory();
    const [isShowTutorial, setIsShowTutorial] = useState(false)
    const [loading, setLoading] = useState(false);
    const [rollOverModal, setRollOverModal] = useState(false);
    const [activeCallTab, setActiveCallTab] = useState("call")
    const [attentionCount, setAttentionCount] = useState({
        unread_comments_offer_count: 0,
        unaccepted_offer_count: 0,
        non_confirmed_task_offer_count: 0
    })
    const [businessGoalCountData, setBusinessGoalCountData] = useState({
        active: 0,
        completed:0,
        all:0
    })

    const [offerCountData, setOfferCountData] = useState({
        active: 0,
        completed: 0,
        all: 0
    })

    const [deliverableCountData, setDeliverableCount] = useState({
        last_thirty_days: 0,
        all: 0
    })

    const [companyCreditsData, setCompanyCredits] = useState({
        total_count: 0,
        covered_by_monthly_plan: 0,
        purchased: 0,
        expiration_covered_by_monthly_plan: null,
        expiration_purchased: 0,
        expired_at: ""
    })

    const [upcomingCallsData, setUpcomingCallsData] = useState<{ id: number, link: string, date: number, call_type: { title: string } }[]>([])

    const [followUpList, setFollowUpList] = useState<FollowUpType[]>([])

    const [suggestedWorksData, setSuggestedWorks] = useState<{
        id: number
        title: string
        project_suggestions: any[]
    }[]>([])

    const [workInProgress, setWorkInProgress] = useState<{
        id: number
        title: string,
        created_at: number,
        updated_at: number,
    }[]>([])

    const [completedDeliverablesData, setCompletedDeliverablesData] = useState<{
        id: number
        title: string
        deliverable_count: string
        created_at: number,
        offer_id: string
    }[]>([])

    const [attentionBlockItems, setAttentionBlockItems] = useState<{ id: number, title: string, type: string, icon: string }[]>([])

    const getData = async () => {
        document.title = "Home page"

        setLoading(true);
        try {
            const { data: companies } = await customAxios.get(`/company/company/get-companies`)
            const companyId = companies[0].id

            const { data: businessGoalCount } = await customAxios.get(`/business-goal/count?company_id=${companyId}`)
            setBusinessGoalCountData(businessGoalCount)

            const { data: offerCount } = await customAxios.get(`/company/${companyId}/offer/count`)
            setOfferCountData(offerCount)

            const { data: deliverableCount } = await customAxios.get(`/company/${companyId}/deliverable/count`)
            setDeliverableCount(deliverableCount)

            const { data: companyCredits } = await customAxios.get(`/company/${companyId}/credits`)
            const { data: exAt } = await customAxios.get(`/company/${companyId}/credits-by-date`)
            setCompanyCredits({
                ...companyCredits,
                expired_at: exAt[exAt.length - 1]?.expired_at
            })

            const { data: upcomingCalls } = await customAxios.get(`/call/list?status_list[]=0&per_page_count=2&page=1`)
            setUpcomingCallsData(upcomingCalls?.calls)

            const { data: followUps } = await customAxios.get(`/call-follow-up/list?per_page_count=2&page=1&company_id=${companyId}&statuses[]=1`)
            setFollowUpList(followUps.call_follow_ups)

            const { data: suggestedWorks } = await customAxios.get(`/company/${companyId}/business-goals?limit=3&order_by_newest_suggestion=1&is_empty_suggestion_project=1`)
            setSuggestedWorks(suggestedWorks)

            const { data: workInProgress } = await customAxios.get(`/company/${companyId}/offer/last-updated?limit=3`)
            setWorkInProgress(workInProgress)

            const { data: completedDeliverables } = await customAxios.get(`/company/${companyId}/task/by-deliverable?limit=3`)
            setCompletedDeliverablesData(completedDeliverables)

            const { data: attentionCountData } = await customAxios.get(`/company/client/kanban/offers-count`)
            setAttentionCount(attentionCountData)

            const { data: attentionBlockItemsDataTasks } = await customAxios.get(`/company/offer/by-not-paid-tasks`)
            const { data: attentionBlockItemsDataOffers } = await customAxios.get(`/company/offer/by-unaccepted-status`)
            const { data: attentionBlockItemsDataSuggestions } = await customAxios.get(`/company/${companyId}/business-goals?order_by_newest_suggestion=1&is_empty_suggestion_project=1`)

            setAttentionBlockItems([
                ...attentionBlockItemsDataTasks.map((item: any) => ({ id: item.id, title: `Confirm new step in task "${item.title}"`, type: "offer", icon: "offer" })),
                //...attentionBlockItemsDataOffers.map((item: any) => ({ id: item.id, title: `Accept new offer "${item.title}"`, type: "offer", icon: "new-offer" })),
                ...attentionBlockItemsDataSuggestions.map((item: any) => ({ id: item.id, title: `Start suggested works in "${item.title}"`, type: "legal-projects", icon: "suggestion" })),
            ])

        } catch (e) {}
        setLoading(false)
    }

    const closeTutorial = async () => {
        setLoading(true)
        try {
            const { status } = await customAxios.get(`/user/client/tutorial-completed`)
            if (status === 200) {
                setIsShowTutorial(false)
            }

        } catch (e) {}
        setLoading(false)
    }

    useEffect(() => {
       getData()
    }, [])

    const attentionIcons = (type: string) => {
        switch (type) {
            case "offer": return attentionIcon
            case "new-offer": return attentionOfferIcon
            case "suggestion": return attentionTasksIcon
        }
    }

    return (
        <div>
            {loading && <CustomLoader />}
            <CSSTransition in={!loading} timeout={200} classNames={'my-node'} unmountOnExit>
                <div className={"client-dashboard"}>
                    <div className="client-dashboard__counters">
                        <div className="client-dashboard__counter">
                            <div className="client-dashboard__counter-head">
                                Projects
                            </div>
                            <div className="client-dashboard__counter-body">
                                <p>
                                    <span><b>{businessGoalCountData.active}</b> Active</span>
                                    <span><b>{businessGoalCountData.completed}</b> Completed</span>
                                </p>
                                <h6>{businessGoalCountData.all}</h6>
                            </div>
                            {+businessGoalCountData.all > 0 &&
                                <NavLink to={"/legal-projects"} className="client-dashboard__counter-button">VIEW ALL</NavLink>}
                        </div>
                        <div className="client-dashboard__counter">
                            <div className="client-dashboard__counter-head">
                                Tasks
                            </div>
                            <div className="client-dashboard__counter-body">
                                <p>
                                    <span><b>{offerCountData.active}</b> Active</span>
                                    <span><b>{offerCountData.completed}</b> Completed</span>
                                </p>
                                <h6>{offerCountData.all}</h6>
                            </div>
                            {+offerCountData.all > 0 &&
                                <NavLink to={"/tasks"} className="client-dashboard__counter-button">VIEW ALL</NavLink>}
                        </div>
                        <div className="client-dashboard__counter">
                            <div className="client-dashboard__counter-head">
                                Deliverables
                            </div>
                            <div className="client-dashboard__counter-body">
                                <p>
                                <span>
                                    <b>{deliverableCountData.last_thirty_days}</b> new deliverables in past 30 days
                                </span>
                                </p>
                                <h6>{deliverableCountData.all}</h6>
                            </div>
                            {+deliverableCountData.all > 0 &&
                                <NavLink to={"/document?page=1&tab=deliverables"} className="client-dashboard__counter-button">VIEW ALL</NavLink>}
                        </div>
                        <div className="client-dashboard__counter credit-counter">
                            <div style={{ color: "#fff" }} className="client-dashboard__counter-head">
                                Credits
                            </div>
                            <div className="client-dashboard__counter-body">
                                {(companyCreditsData.expired_at && companyCreditsData.total_count > 0) && <p style={{ maxWidth: "200px" }}>
                                    <span className={"flex alignCenter"}>Expiration {companyCreditsData.expired_at} <img className={"ml5 pointer"} onClick={() => setRollOverModal(true)} src={rollOverInfoIcon} alt=""/></span>
                                </p>}
                                <h5>{companyCreditsData.total_count}</h5>
                            </div>
                            <NavLink to={"/settings/payment-plan"} className="client-dashboard__counter-button">top up</NavLink>
                        </div>
                    </div>
                    <div className={"flex mt20"}>
                        <div className={"client-dashboard__attention"}>
                            <h2>Needs your attention</h2>
                            {/*{(attentionCount.unread_comments_offer_count > 0) && <div onClick={() => history.push(`/tasks?page=1&filter=0`)}
                                  className="client-dashboard__attention-item">
                                <div className={"flex alignItems"}>
                                    <img className={"client-dashboard__attention-item-img"} src={attentionIcon} alt=""/>
                                    <p>View new comment in the chat</p>
                                </div>
                                <img src={attentionArrowIcon} alt=""/>
                            </div>}
                            {(attentionCount.unaccepted_offer_count > 0) && <div onClick={() => history.push(`/tasks?page=1&filter=1`)}
                                  className="client-dashboard__attention-item">
                                <div className={"flex alignItems"}>
                                    <img className={"client-dashboard__attention-item-img"} src={attentionOfferIcon}
                                         alt=""/>
                                    <p>Accept new offer</p>
                                </div>
                                <img src={attentionArrowIcon} alt=""/>
                            </div>}
                            {(attentionCount.non_confirmed_task_offer_count > 0) && <div onClick={() => history.push(`/tasks?page=1&filter=2`)}
                                  className="client-dashboard__attention-item">
                                <div className={"flex alignItems"}>
                                    <img className={"client-dashboard__attention-item-img"} src={attentionTasksIcon}
                                         alt=""/>
                                    <p>Confirm Steps</p>
                                </div>
                                <img src={attentionArrowIcon} alt=""/>
                            </div>}
                            {((attentionCount.unaccepted_offer_count === 0) && (attentionCount.unread_comments_offer_count === 0) && (attentionCount.non_confirmed_task_offer_count === 0)) && <div className={"client-dashboard__calls-empty flex alignCenter justifyCenter"}>
                                <div>
                                    You’re all caught up. <br/>
                                    We’ll notify you as soon as there’s something <br/>
                                    that needs your attention.
                                </div>
                            </div>}*/}
                            {attentionBlockItems.length > 0 && <div className="client-dashboard__attention-container">
                                {
                                    attentionBlockItems.map((item) => (
                                        <div onClick={() => history.push(`/${item.type}/${item.id}`)}
                                             className="client-dashboard__attention-item">
                                            <div className={"flex alignItems"}>
                                                <img className={"client-dashboard__attention-item-img"}
                                                     src={attentionIcons(item.icon)}
                                                     alt=""/>
                                                <p>{item.title}</p>
                                            </div>
                                            <img src={attentionArrowIcon} alt=""/>
                                        </div>
                                    ))
                                }
                            </div>}

                            {attentionBlockItems.length === 0 && <div className={"client-dashboard__calls-empty flex alignCenter justifyCenter"}>
                                You’re all caught up. <br/>
                                We’ll notify you as soon as there’s something <br/>
                                that needs your attention.
                            </div>}
                        </div>

                        <div className="client-dashboard__calls">
                            <h2>
                                <div className={"flex alignItems"}>
                                    <div
                                        onClick={() => setActiveCallTab("call")}
                                        className={`client-dashboard__calls-nav ${activeCallTab === "call" && "client-dashboard__calls-nav-active"}`}>
                                        Upcoming Calls
                                    </div>
                                    <div
                                        onClick={() => setActiveCallTab("follow-up")}
                                        className={`client-dashboard__calls-nav ${activeCallTab === "follow-up" && "client-dashboard__calls-nav-active"}`}>
                                        Follow-Ups
                                    </div>
                                </div>
                                <div className={"flex"}>
                                    {/*<NavLink to={"/book-new-calls"} style={{ marginRight: "18px" }}>Open Expert Calls Hub</NavLink>*/}
                                    {activeCallTab === "call" && upcomingCallsData.length > 0 && <NavLink to={"/upcoming-calls"}>Open Expert Calls Hub</NavLink>}
                                    {activeCallTab === "follow-up" && followUpList.length > 0 && <NavLink to={"/follow-ups"}>Open Expert Calls Hub</NavLink>}
                                </div>
                            </h2>
                            {activeCallTab === "call" && upcomingCallsData.length === 0 && <div className={"client-dashboard__calls-empty flex alignCenter justifyCenter"}>
                                <div>
                                    You do not have any calls booked yet <br />
                                    <NavLink to={"/book-new-calls"}>Book new call</NavLink>
                                </div>
                            </div>}
                            {activeCallTab === "follow-up" && followUpList.length === 0 && <div className={"client-dashboard__calls-empty flex alignCenter justifyCenter"}>
                                No New Follow-Ups available yet
                            </div>}
                            {activeCallTab === "call" && <div>
                                {
                                    (upcomingCallsData || []).map((call) => (
                                        <div key={call.id} className="client-dashboard__calls-item">
                                            <div className={"flex flex-center"}>
                                                <img src={upcomingIcon} alt=""/>
                                                <span>
                                            {call?.call_type?.title}
                                        </span>
                                            </div>
                                            <div className={"flex flex-center"}>
                                                <p>{moment(+call.date * 1000).format("DD/MM/YYYY")}</p>
                                                <p>{moment(+call.date * 1000).format("HH:mm")}</p>
                                                <a target={"_blank"} href={call.link}>
                                                    <button disabled={!call.link}>Join</button>
                                                </a>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>}
                            {activeCallTab === "follow-up" && <div>
                                {
                                    (followUpList || []).map((call) => (
                                        <div key={call.id} className="client-dashboard__calls-item">
                                            <div className={"flex flex-center"}>
                                                <img src={upcomingIcon} alt=""/>
                                                <span>
                                            {call?.call_type?.title}
                                        </span>
                                            </div>
                                            <div className={"flex flex-center"}>
                                                <p>{moment(+call.date * 1000).format("DD/MM/YYYY")}</p>
                                                <p>{moment(+call.date * 1000).format("HH:mm")}</p>
                                                <a target={"_blank"} href={`/follow-ups/${call?.id}`}>
                                                    <button>FOLLOW-UP</button>
                                                </a>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>}
                        </div>
                    </div>
                    <div className={"client-dashboard__tasks mt20"}>
                        <div className="client-dashboard__tasks-col">
                            <h2>
                                <img src={col1Icon} alt=""/>
                                Suggested Tasks
                            </h2>
                            <div className="client-dashboard__tasks-items">
                                {
                                    suggestedWorksData.map((work) => (
                                        <div key={work.id} className="client-dashboard__tasks-item">
                                            <div>
                                                <p>{work.title.length > 60 ? `${work.title.slice(0, 60)}...` : work.title}</p>
                                                <div className={"mt10"}>
                                                    <b className={"mr15"}>{work.project_suggestions.reduce((currentValue, sug) => {
                                                        currentValue += sug.credit_price_estimate;
                                                        return currentValue;
                                                    }, 0)} Credits</b>
                                                    <span>{(work.project_suggestions || []).length} Suggestion{(work.project_suggestions || []).length !== 1 && "s"}</span>
                                                </div>
                                            </div>
                                            <NavLink to={`/legal-projects/${work.id}`}><button>View</button></NavLink>
                                        </div>
                                    ))
                                }
                            </div>
                            {suggestedWorksData.length === 0 && <div className="client-dashboard__empty-block">
                                We’re preparing new suggestions <br/>
                                tailored to your projects. <br/>
                                Once ready, they will appear here.
                            </div>}
                            {suggestedWorksData.length === 3 && <NavLink className={"client-dashboard__tasks-link"} to={"/legal-projects"}>VIEW ALL</NavLink>}
                        </div>
                        <div className="client-dashboard__tasks-col">
                            <h2>
                                <img src={col2Icon} alt=""/>
                                Tasks in Progress
                            </h2>
                            <div className="client-dashboard__tasks-items">
                                {
                                    workInProgress.map((work) => (
                                        <div key={work.id} className="client-dashboard__tasks-item">
                                            <p>{work.title.length > 60 ? `${work.title.slice(0, 60)}...` : work.title}</p>
                                            <div className={"mt10"}>
                                                <em className={"mr15"}>{moment(+work.updated_at * 1000).format("DD/MM/YYYY")}</em>
                                                {/*<b>In progress</b>*/}
                                            </div>
                                            <NavLink to={`/offer/${work.id}`}><button>View</button></NavLink>
                                        </div>
                                    ))
                                }
                            </div>
                            {workInProgress.length === 0 && <div className="client-dashboard__empty-block">
                                <div>No ongoing tasks at the moment</div>
                                <a onClick={() => setModalType('client_kanban_request')}>Create New Task</a>
                            </div>}
                            {workInProgress.length === 3 && <NavLink className={"client-dashboard__tasks-link"} to={"/tasks"}>VIEW ALL</NavLink>}
                        </div>
                        <div className="client-dashboard__tasks-col">
                            <h2>
                                <img src={col3Icon} alt=""/>
                                Completed Tasks
                            </h2>
                            <div className="client-dashboard__tasks-items">
                                {
                                    completedDeliverablesData.map((deliverable) => (
                                        <div className="client-dashboard__tasks-item">
                                            <p>{deliverable.title.length > 60 ? `${deliverable.title.slice(0, 60)}...` : deliverable.title}</p>
                                            <div className={"mt10"}>
                                                <em className={"mr15"}>{moment(+deliverable.created_at * 1000).format("DD/MM/YYYY")}</em>
                                                {/*<b>Completed</b>*/}
                                            </div>
                                            <div className={"mt5"}>
                                                <em className={"mr15"}>Deliverables</em>
                                                <b>{deliverable.deliverable_count}</b>
                                            </div>
                                            <NavLink to={`/offer/${deliverable.offer_id}`}><button>View</button></NavLink>
                                        </div>
                                    ))
                                }
                            </div>
                            {completedDeliverablesData.length === 0 && <div className="client-dashboard__empty-block">
                                Your completed tasks <br/>
                                will be displayed here
                            </div>}
                            {completedDeliverablesData.length === 3 && <NavLink className={"client-dashboard__tasks-link"} to={"/document?page=1&tab=deliverables"}>VIEW ALL</NavLink>}
                        </div>
                    </div>
                </div>
            </CSSTransition>
            <RollOverModal isOpen={rollOverModal} close={() => setRollOverModal(false)} />
            <WelcomeAboard isOpen={isAbroadModal} close={() => {
                dispatch(closeAbroadModal(false))
                setIsShowTutorial(true)
            }} />
            {!loading && isShowTutorial && <CustomTour close={closeTutorial} />}
        </div>

    )
}